export const PRICE_TRACKER_CHART_ID = 'suburb-price-tracker-chart'

let captureGetPng = null

export const registerPriceTrackerChartCapture = (getPng) => {
  captureGetPng = typeof getPng === 'function' ? getPng : null
}

export const unregisterPriceTrackerChartCapture = () => {
  captureGetPng = null
}

const waitForChartInDom = (timeoutMs = 5000) =>
  new Promise((resolve) => {
    const hasChart = () => {
      const node = document.getElementById(PRICE_TRACKER_CHART_ID)
      return node?.querySelector('svg.recharts-surface') ? node : null
    }

    const found = hasChart()
    if (found) {
      resolve(found)
      return
    }

    const deadline = Date.now() + timeoutMs
    const tick = () => {
      const node = hasChart()
      if (node) {
        resolve(node)
        return
      }
      if (Date.now() >= deadline) {
        resolve(null)
        return
      }
      requestAnimationFrame(tick)
    }
    requestAnimationFrame(tick)
  })

/** Returns PNG data URL from desktop PRICE TRACKER chart, or null if unavailable. */
export const capturePriceTrackerChartForPdf = async () => {
  if (typeof document === 'undefined' || !captureGetPng) return null

  let node = document.getElementById(PRICE_TRACKER_CHART_ID)
  if (!node?.querySelector('svg.recharts-surface')) {
    node?.scrollIntoView({ block: 'center', behavior: 'instant' })
    node = await waitForChartInDom()
  }
  if (!node) return null

  await new Promise((resolve) => {
    requestAnimationFrame(() => requestAnimationFrame(resolve))
  })

  try {
    return (await captureGetPng()) || null
  } catch (e) {
    console.warn('Price tracker chart capture failed', e)
    return null
  }
}
